import React, { type ReactNode } from 'react'

import { Tag, type TagProps } from '@fourthwall/components'

import * as S from './DetailsListItem.styled'

export type DetailsListItemProps = {
  title: ReactNode
  subtitle: string
  tagProps?: TagProps
  actionButton?: ReactNode
}

export const DetailsListItem = ({
  title,
  subtitle,
  tagProps,
  actionButton,
}: DetailsListItemProps) => (
  <S.ItemContainer>
    <S.Content>
      <S.Title>{title}</S.Title>
      <S.Subtitle>{subtitle}</S.Subtitle>
    </S.Content>
    <S.ActionsContainer>
      {tagProps && (
        <S.TagContainer>
          <Tag {...tagProps} />
        </S.TagContainer>
      )}
      {actionButton}
    </S.ActionsContainer>
  </S.ItemContainer>
)
